import { Button, Col, Row } from 'react-bootstrap';
import { get } from 'lodash';
import { FormattedNumber } from 'react-intl';
import { FaSpinner } from 'react-icons/fa';
import React = require('react');
import { CancellationReasons } from '../../../../../../../../services/mta/models';

export const CancelRefund = ({ formValues, refundAmount, currency, ...props }) => {

  const renderRefund = () => {
    const cancellationReason = get(formValues, 'meta.reason.cancellation_reason', null);
    const allowRefundOnSelections = [
      CancellationReasons.NOT_TRAVELLING_SOON,
      CancellationReasons.TOO_EXPENSIVE,
      CancellationReasons.COVER_NOT_SUITABLE,
      CancellationReasons.POOR_SERVICE,
      CancellationReasons.OTHER
    ]
    const isDropdownSelected = cancellationReason !== null

    if (!allowRefundOnSelections.includes(cancellationReason)) {
      return;
    }

    if (isDropdownSelected && refundAmount > 0) {
      return (
        <>
          <div
            className={'dynamic-row'}
            style={{ display: 'flex', marginTop: '30px', justifyContent: 'space-between' }}
          >
            <div style={{ alignContent: 'center' }}>
              <b>Refund amount (inc. IPT)</b>{'  '} <b>
              <FormattedNumber
                value={refundAmount}
                style="currency"
                currency={currency}
              /></b>
            </div>
            <div>
              {renderCancelConfirmButton()}
            </div>
          </div>
        </>
      )
    }

    if (isDropdownSelected && refundAmount <= 0) {
      return (
        <>
          <div
            className={'dynamic-row'}
            style={{ display: 'flex', marginTop: '30px', justifyContent: 'space-between' }}
          >
            <div style={{ maxWidth: '60%' }}>
              A refund will not be made as you are cancelling your policy after your 14-day cooling off period
            </div>
            <div>
              {renderCancelConfirmButton()}
            </div>
          </div>
        </>
      )
    }
  }

  const handleConfirmButton = () => {
    const { actions } = props;
    actions.push('/account/make-a-change/cancel-confirm')
  }

  const renderCancelConfirmButton = () => {
    const { submitting, submitFailed, valid, isLoading } = props;
    return (
      <Button
        bsStyle="primary"
        type="button"
        bsSize="small"
        className="medium-width secondary-button"
        onClick={handleConfirmButton}
        disabled={submitting || (submitFailed && !valid || !valid || isLoading)}>
        {isLoading && (
          <FaSpinner className="fa-spin"/>
        )}
        CONFIRM
      </Button>
    )
  }

  return (
    <>
      {renderRefund()}
    </>
  )
}
